// extracted by mini-css-extract-plugin
module.exports = {"table":"_1AqaiSpRx8uXSx_KdigM8H","tableHeader":"_3qiy_Zs_UCmh81H4PDUjFT","tableRow":"_2U95CQ2cUcL2PpUNW5dgDK","selectedRow":"_18U0tT_qcOW0bj6mmq0JGA"};